<template>
  <div>
    <div class="mpf-panel">
      <h1 class="mpf-panel__title">{{ panelTitle ?? 'Questionnaire submitted' }}</h1>
      <div class="mpf-panel__body">Your answers have been sent to the surgery.</div>
    </div>

    <p>
      Your answers are now part of your medical record. We will contact you if anything needs
      following up.
    </p>

    <p class="mpf-heading-s">If your health concern is urgent or you're not sure:</p>
    <ul>
      <li v-if="tenant?.localOrganisation.phone">
        call the surgery on
        <a :href="`tel:${tenant?.localOrganisation.phone}`" class="mpf-link">{{
          tenant?.localOrganisation.phone
        }}</a>
      </li>
      <li v-if="isNhsJurisdiction">
        if the surgery is closed, phone 111 or go to
        <a href="https://111.nhs.uk/" target="_blank" rel="noopener noreferrer" class="mpf-link"
          >NHS 111 online</a
        >
      </li>
      <li>in an emergency, phone 999 or go to A&amp;E</li>
    </ul>

    <p v-if="!isOpenInNhsApp">You may now close this window.</p>
  </div>
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia';
  import { useTenantStore } from '@/stores/useTenantStore';
  import { useNhsAppStore } from '@/stores/useNhsAppStore';
  import { useRouteMeta } from '../composables/useRouteMeta';

  const tenantStore = useTenantStore();
  const nhsAppStore = useNhsAppStore();

  const { tenant, isNhsJurisdiction } = storeToRefs(tenantStore);
  const { isOpenInNhsApp } = storeToRefs(nhsAppStore);
  const { panelTitle } = useRouteMeta();
</script>
